module.exports = __webpack_public_path__ + "img/icon5.3518bc9.png";